import {
  graphql,
  type ResultOf,
  type VariablesOf,
} from "@/data-access/graphql";
import { BriefingDefinitionFragment } from "../fragments/briefing-definition-fragments";

export const GetBriefingDefinition = graphql(
  `
    query getBriefingDefinition($id: ID!) {
      briefingDefinitions(filters: { id: $id }, first: 1) {
        edges {
          node {
            ...BriefingDefinitionFragment
          }
        }
      }
    }
  `,
  [BriefingDefinitionFragment],
);

export const CreateBriefingDefinition = graphql(
  `
    mutation createBriefingDefinition($input: CreateBriefingDefinitionInput!) {
      createBriefingDefinition(input: $input) {
        ... on BriefingDefinition {
          ...BriefingDefinitionFragment
        }
        ... on OperationInfo {
          __typename
          messages {
            code
            field
            kind
            message
          }
        }
      }
    }
  `,
  [BriefingDefinitionFragment],
);

export const UpdateBriefingDefinition = graphql(
  `
    mutation updateBriefingDefinition(
      $id: ID!
      $expectedUpdatedAt: DateTime!
      $input: UpdateBriefingDefinitionInput!
    ) {
      updateBriefingDefinition(
        id: $id
        expectedUpdatedAt: $expectedUpdatedAt
        input: $input
      ) {
        ... on BriefingDefinition {
          ...BriefingDefinitionFragment
        }
        ... on OperationInfo {
          __typename
          messages {
            code
            field
            kind
            message
          }
        }
      }
    }
  `,
  [BriefingDefinitionFragment],
);

export const PauseBriefingDefinition = graphql(
  `
    mutation pauseBriefingDefinition($id: ID!) {
      pauseBriefingDefinition(id: $id) {
        ... on BriefingDefinition {
          ...BriefingDefinitionFragment
        }
        ... on OperationInfo {
          __typename
          messages {
            code
            field
            kind
            message
          }
        }
      }
    }
  `,
  [BriefingDefinitionFragment],
);

export const ResumeBriefingDefinition = graphql(
  `
    mutation resumeBriefingDefinition($id: ID!) {
      resumeBriefingDefinition(id: $id) {
        ... on BriefingDefinition {
          ...BriefingDefinitionFragment
        }
        ... on OperationInfo {
          __typename
          messages {
            code
            field
            kind
            message
          }
        }
      }
    }
  `,
  [BriefingDefinitionFragment],
);

export const DeleteBriefingDefinition = graphql(`
  mutation deleteBriefingDefinition($id: ID!) {
    deleteBriefingDefinition(id: $id) {
      ... on SuccessResponse {
        __typename
        message
      }
      ... on OperationInfo {
        __typename
        messages {
          code
          field
          kind
          message
        }
      }
    }
  }
`);

/** `BriefingDeliverySchedule` from `CreateBriefingDefinitionInput.sendOn`; `NonNullable` drops the `undefined` added by its schema default. */
export type BriefingDefinitionDeliverySchedule = NonNullable<
  VariablesOf<typeof CreateBriefingDefinition>["input"]["sendOn"]
>;

export type DeleteBriefingDefinitionPayload = ResultOf<
  typeof DeleteBriefingDefinition
>["deleteBriefingDefinition"];
